import { User } from '../models/api/User/User';

export class BasicUserService {
	protected readonly identityUserProvider: IndentityUserProvider;

	/**
	 * @param scope - optional OAuth scope to control which user data to get
	 */
	constructor(scope?: string) {
		this.identityUserProvider = new IndentityUserProvider(scope || T.Utils.Auth.scope);
	}

	/**
	 * Tries to get the user model, if the user is currently logged in.
	 * (Currently this call may result in several redirects to get a token for reading the user data)
	 * Callback receives user model with user data or empty user model (check with Valid) if the user is not logged in.
	 */
	public getUser(callback: (user: User) => void): void {
		this.identityUserProvider.getUserData((identityUserData) => {
			if (identityUserData) {
				callback(User.createFromObject(identityUserData));
			} else {
				callback(new User());
			}
		});
	}

	/**
	 * Invalidate User to reset its state for new user retrieval from webservice
	 */
	public invalidate(): void {
		this.clearUserPersistence();
	}

	/**
	 * Clear the persisted user used for user initialization
	 */
	protected clearUserPersistence(): void {
		this.identityUserProvider.clearUserPersistence();
	}
}

/**
 * Gets the user data from the login, if the user is logged in.
 */
class IndentityUserProvider {
	protected readonly scope: string;
	constructor(scope: string) {
		this.scope = scope;
	}

	/**
	 * Gets the user data from the application identity. Currently this call may result in several redirects to get a token for reading the user data.
	 *
	 * @param callback - name callback: the callback to call with optional user data after processing finished.
	 */
	public getUserData(callback: (dataObject: { [key: string]: any }) => void): void {
		T.Utils.Auth.getResolvedIdentity(callback, {
			scope: this.scope
		});
	}

	/**
	 * Clear the persisted user used for user initialization
	 */
	public clearUserPersistence(): void {
		T.Utils.Store.set('Application.Identity', null, T.Utils.Store.SESSION);
	}
}
